import React from "react";
import Menu from "../Component/Menu";
import DriverManagement from "../Pages/DriverManagement";
import Dashboard from "../Pages/Dashboard";
import Account from "../Pages/Account";
import { Routes, Route } from "react-router-dom";
import RiderManagement from "../Pages/RiderManagement";
import Driverdata from "../Component/Driverdata";
import CustomerManagement from "../Pages/CustomerManagement";
import Approval from "../Pages/Approval";
import Wallet from "../Pages/Wallet";
import VehicleandPayment from "../Pages/VehicleandPayment";
import Driverspecificpayment from "../Component/Driverspecificpayment";
import Locationpage from "../Pages/Locationpage";
import BannerandReviews from "../Pages/BannerandReviews";
import Ridetrack from "../Component/Ridetrack";
import Chatpage from "../Pages/Chatpage";
import Helpandsupport from "../Pages/Helpandsupport";
import Role from "../Pages/Role";
import Resource from "../Pages/Resource";
import RoleCreate from "../Component/Rolemanagement/RoleCreate";
import ResourceCreate from "../Component/Resource/ResourceCreate";
import Announcement from "../Pages/Announcement";
import WalletReruest from "../Pages/WalletReruest";

import CMSManagement from "../Pages/CMSManagement";
import VersionControl from "../Pages/VersionControl";

const Approutes = () => {
  return (
    <Routes>
      <Route index element={<Dashboard />} />
      <Route path="drivers" element={<DriverManagement />} />
      <Route path="driversdata/:type/:id" element={<Driverdata />} />
      <Route path="customer" element={<CustomerManagement />} />
      <Route path="customerdata/:type/:id" element={<Driverdata />} />
      <Route path="rides" element={<RiderManagement />} />
      <Route path="ridestrack/:id" element={<Ridetrack />} />
      <Route path="approval" element={<Approval />} />
      <Route path="wallet" element={<Wallet />} />
      <Route path="messages" element={<Chatpage />} />
      <Route path="prices" element={<VehicleandPayment />} />
      <Route
        path="drivervehicledetails/:type/:id"
        element={<Driverspecificpayment />}
      />
      <Route path="location" element={<Locationpage />} />
      <Route path="splash" element={<BannerandReviews />} />
      <Route path="roles" element={<Role />} />
      <Route path="roles/create" element={<RoleCreate />} />
      <Route path="roles/edit/:id" element={<RoleCreate />} />
      <Route path="resource" element={<Resource />} />
      <Route path="resource/create" element={<ResourceCreate />} />
      <Route path="resource/edit/:id" element={<ResourceCreate />} />
      <Route path="help" element={<Helpandsupport />} />
      <Route path="announcement" element={<Announcement />} />
      <Route path="account" element={<Account />} />
      <Route path="request" element={<WalletReruest />} />
      <Route path="cms" element={<CMSManagement />} />
      <Route path="version-control" element={<VersionControl />} />
    </Routes>
  );
};

export default Approutes;
